import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import CheckIcon from './assets/checkbox_icon.svg';
import UKLoadingIcon, { CIRCLE_COLOR_MAP, SIZE_MAP } from '@/components/UKLoadingIcon';
import style from './index.module.scss';

const CheckboxIcon = styled('span')({
  borderRadius: 4,
  width: 20,
  height: 20,
  backgroundColor: '#ffffff',
  border: '1px solid #888B94',
  'input:disabled ~ &': {
    borderColor: 'var(--sys-Surface-Outline200)',
    backgroundColor: '#F5F7FA',
  },
});

const CheckboxCheckedIcon = styled(CheckboxIcon)({
  backgroundColor: 'var(--sys-Text-Primary)',
  borderColor: 'var(--sys-Text-Primary)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

interface UKCheckboxProps {
  checked: boolean;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  slotProps?: any;
  sx?: any;
  loading?: boolean;
  checkboxClassName?: string;
  loadingBoxClassName?: string;
}

const UKCheckbox: FC<UKCheckboxProps> = ({
  checked,
  disabled,
  onClick,
  sx,
  slotProps,
  loading,
  checkboxClassName,
  loadingBoxClassName,
}) => {
  return loading ? (
    <div className={`${style.loadBox} ${loadingBoxClassName}`}>
      <UKLoadingIcon size={SIZE_MAP.SIZE_24} type={CIRCLE_COLOR_MAP.BLACK} />
    </div>
  ) : (
    <Checkbox
      className={checkboxClassName}
      edge='start'
      checked={checked}
      disabled={disabled}
      onClick={onClick}
      sx={sx}
      disableRipple
      checkedIcon={<CheckboxCheckedIcon>{!disabled && <CheckIcon />}</CheckboxCheckedIcon>}
      icon={<CheckboxIcon />}
      {...slotProps}
    />
  );
};

export default UKCheckbox;
